import Employee from './Employee'
export class GetDataRequest {
    Employee: Employee;
}

export default GetDataRequest;